import requestSC from "@/utils/requestSC";
import requestApi from "@/utils/requestApi";

//查询商品列表（spu下挂sku列表）
export function getGoodsSpuList(params) {
  return requestSC.get(`/rest/mj/goods/seq/spu/list`, {
    params,
  });
}

//SKU归属关系调整（skuA从spuA移动到spuB）
export function goodsSkuTransform(params) {
  return requestSC.post("/rest/mj/goods/seq/skuTransform", params);
}

//商品上下架
export function goodsModifyStatus(params) {
  return requestSC.post("/rest/mj/goods/seq/modifyStatus", params);
}

//设置商品 店铺自定义分类
export function goodsShopClassifyAdd(params) {
  return requestSC.post("/rest/mj/goods/seq/shopClassify/add", params);
}

//移除自定义分类
export function goodsShopClassifyDelete(params) {
  return requestSC.post("/rest/mj/goods/seq/shopClassify/delete", params);
}

//删除商品
export function goodsDelete(params) {
  return requestSC.post("/rest/mj/goods/seq/delete", params);
}

//批量更新商品
export function goodsBatchModify(params) {
  return requestSC.post("/rest/mj/goods/sep/batch/modify", params);
}

// 更新库存
export function editCurrQuantity(params) {
  return requestApi.post("/sctrading/goods/mj/editCurrQuantity", params);
}
